export default __webpack_public_path__ + "static/media/3082.331c8ea2.jpg";